import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/leads";

export async function addLead(proposal_id, searchType) {
  const response = await instance.post("/add", {
    proposal_id,
    search_type: searchType,
  });
  return response.data;
}

export async function setReminder(proposal_id, reminder) {
  const response = await instance.post("/set_reminder", {
    proposal_id,
    reminder,
  });
  return response.data;
}

export async function removeLead(proposal_id, searchType) {
  const response = await instance.post("/remove", {
    proposal_id,
    search_type: searchType,
  });
  return response.data;
}

export async function getLeads() {
  const response = await instance.get(`/get`, { timeout: 10000 });
  return response.data;
}

export async function getLeadsContracts() {
  const response = await instance.get(`/get_contracts`, { timeout: 60000 });
  return response.data;
}

export async function getAllLeads() {
  const response = await instance.get(`/get_leads`, { timeout: 10000 });
  return response.data;
}
